module.exports = __webpack_public_path__ + "static/media/update_timer_black.f9ad58ec.svg";